export enum ActiveOfferView {
  None,
  OfferViewList,
  OfferView,
}
